(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefdb2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefdb2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i3NRd", function(module, exports) {
module.exports = {};

});

/*
|--------------------------------------------------------------------------
| App.TS
|
| Import statements must go at the top before any other code
|--------------------------------------------------------------------------
*/ // Automatically includes TS/JS from the /components directory
/**
 * Auto Template Component
 *
 * Automatically imports and initializes JavaScript/TypeScript modules
 * from the /components directory based on DOM element IDs.
 */ function $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $5cde60a45dc0f6ff$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $5cde60a45dc0f6ff$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $1ed5d5037721a118$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


var $533656838d3b3c79$import_meta = Object.assign(Object.create(null), {
    url: "file:///src/ts/core/auto-template-component.ts"
});

var $533656838d3b3c79$var$autoTemplateComponent = function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $5cde60a45dc0f6ff$export$71511d61b312f219)(function() {
        var components, allComponents, error, _env;
        return (0, $1ed5d5037721a118$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (parcelRequire("i3NRd"))
                    ];
                case 1:
                    components = _state.sent();
                    if (components) {
                        allComponents = Object.keys(components);
                        allComponents.forEach(function(component) {
                            var element = document.getElementById("js-".concat(component));
                            if (element !== null) {
                                var _components_component;
                                var mod = (_components_component = components[component]) === null || _components_component === void 0 ? void 0 : _components_component[component];
                                if (mod && typeof mod === 'function') mod();
                            }
                        });
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    // No components found or import failed - this is expected if no component JS exists
                    if ((_env = $533656838d3b3c79$import_meta.env) === null || _env === void 0 ? void 0 : _env.DEV) console.debug('No component modules found or failed to load:', error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
};
var $533656838d3b3c79$export$2e2bcd8739ae039 = $533656838d3b3c79$var$autoTemplateComponent;


/*
|--------------------------------------------------------------------------
| Footer Shader - Interactive Fluid/Splash Cursor Effect
|
| A WebGL fluid simulation that responds to cursor movement
| Creates organic, flowing splashes in Alchemy's violet brand color
|--------------------------------------------------------------------------
*/ // Configuration
function $bf2e53ae99fda9f5$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $ac98c22c37821d14$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ac98c22c37821d14$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $ac98c22c37821d14$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ac98c22c37821d14$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $2b1f4dace316f7be$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $24b01363b51bd19a$var$config = {
    SIM_RESOLUTION: 100,
    DYE_RESOLUTION: 600,
    SPLAT_RADIUS: 0.12,
    SPLAT_FORCE: 3000,
    CURL: 30,
    PRESSURE_ITERATIONS: 20,
    VELOCITY_DISSIPATION: 0.985,
    DENSITY_DISSIPATION: 0.98,
    // Alchemy violet color (normalized RGBA)
    COLOR: {
        r: 0.714,
        g: 0.306,
        b: 1.0,
        a: 0.5
    }
};
// Shader sources
var $24b01363b51bd19a$var$baseVertexShader = "\n  precision highp float;\n  attribute vec2 aPosition;\n  varying vec2 vUv;\n  varying vec2 vL;\n  varying vec2 vR;\n  varying vec2 vT;\n  varying vec2 vB;\n  uniform vec2 texelSize;\n\n  void main () {\n    vUv = aPosition * 0.5 + 0.5;\n    vL = vUv - vec2(texelSize.x, 0.0);\n    vR = vUv + vec2(texelSize.x, 0.0);\n    vT = vUv + vec2(0.0, texelSize.y);\n    vB = vUv - vec2(0.0, texelSize.y);\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n  }\n";
var $24b01363b51bd19a$var$clearShader = "\n  precision mediump float;\n  precision mediump sampler2D;\n  varying highp vec2 vUv;\n  uniform sampler2D uTexture;\n  uniform float value;\n\n  void main () {\n    gl_FragColor = value * texture2D(uTexture, vUv);\n  }\n";
var $24b01363b51bd19a$var$displayShader = "\n  precision highp float;\n  precision highp sampler2D;\n  varying vec2 vUv;\n  uniform sampler2D uTexture;\n\n  void main () {\n    vec3 c = texture2D(uTexture, vUv).rgb;\n    float intensity = max(c.r, max(c.g, c.b));\n    vec3 muted = c * 0.15;\n    float a = intensity * 0.05;\n    gl_FragColor = vec4(muted, a);\n  }\n";
var $24b01363b51bd19a$var$splatShader = "\n  precision highp float;\n  precision highp sampler2D;\n  varying vec2 vUv;\n  uniform sampler2D uTarget;\n  uniform float aspectRatio;\n  uniform vec4 color;\n  uniform vec2 point;\n  uniform float radius;\n\n  void main () {\n    vec2 p = vUv - point.xy;\n    p.x *= aspectRatio;\n    float d = exp(-dot(p, p) / radius);\n    vec3 splat = d * color.rgb * color.a;\n    vec3 base = texture2D(uTarget, vUv).xyz;\n    gl_FragColor = vec4(base + splat, 1.0);\n  }\n";
var $24b01363b51bd19a$var$advectionShader = "\n  precision highp float;\n  precision highp sampler2D;\n  varying vec2 vUv;\n  uniform sampler2D uVelocity;\n  uniform sampler2D uSource;\n  uniform vec2 texelSize;\n  uniform float dt;\n  uniform float dissipation;\n\n  void main () {\n    vec2 coord = vUv - dt * texture2D(uVelocity, vUv).xy * texelSize;\n    gl_FragColor = dissipation * texture2D(uSource, coord);\n    gl_FragColor.a = 1.0;\n  }\n";
var $24b01363b51bd19a$var$divergenceShader = "\n  precision mediump float;\n  precision mediump sampler2D;\n  varying highp vec2 vUv;\n  varying highp vec2 vL;\n  varying highp vec2 vR;\n  varying highp vec2 vT;\n  varying highp vec2 vB;\n  uniform sampler2D uVelocity;\n\n  void main () {\n    float L = texture2D(uVelocity, vL).x;\n    float R = texture2D(uVelocity, vR).x;\n    float T = texture2D(uVelocity, vT).y;\n    float B = texture2D(uVelocity, vB).y;\n    vec2 C = texture2D(uVelocity, vUv).xy;\n    if (vL.x < 0.0) { L = -C.x; }\n    if (vR.x > 1.0) { R = -C.x; }\n    if (vT.y > 1.0) { T = -C.y; }\n    if (vB.y < 0.0) { B = -C.y; }\n    float div = 0.5 * (R - L + T - B);\n    gl_FragColor = vec4(div, 0.0, 0.0, 1.0);\n  }\n";
var $24b01363b51bd19a$var$curlShader = "\n  precision mediump float;\n  precision mediump sampler2D;\n  varying highp vec2 vUv;\n  varying highp vec2 vL;\n  varying highp vec2 vR;\n  varying highp vec2 vT;\n  varying highp vec2 vB;\n  uniform sampler2D uVelocity;\n\n  void main () {\n    float L = texture2D(uVelocity, vL).y;\n    float R = texture2D(uVelocity, vR).y;\n    float T = texture2D(uVelocity, vT).x;\n    float B = texture2D(uVelocity, vB).x;\n    float vorticity = R - L - T + B;\n    gl_FragColor = vec4(0.5 * vorticity, 0.0, 0.0, 1.0);\n  }\n";
var $24b01363b51bd19a$var$vorticityShader = "\n  precision highp float;\n  precision highp sampler2D;\n  varying vec2 vUv;\n  varying vec2 vL;\n  varying vec2 vR;\n  varying vec2 vT;\n  varying vec2 vB;\n  uniform sampler2D uVelocity;\n  uniform sampler2D uCurl;\n  uniform float curl;\n  uniform float dt;\n\n  void main () {\n    float L = texture2D(uCurl, vL).x;\n    float R = texture2D(uCurl, vR).x;\n    float T = texture2D(uCurl, vT).x;\n    float B = texture2D(uCurl, vB).x;\n    float C = texture2D(uCurl, vUv).x;\n    vec2 force = 0.5 * vec2(abs(T) - abs(B), abs(R) - abs(L));\n    force /= length(force) + 0.0001;\n    force *= curl * C;\n    force.y *= -1.0;\n    vec2 vel = texture2D(uVelocity, vUv).xy;\n    gl_FragColor = vec4(vel + force * dt, 0.0, 1.0);\n  }\n";
var $24b01363b51bd19a$var$pressureShader = "\n  precision mediump float;\n  precision mediump sampler2D;\n  varying highp vec2 vUv;\n  varying highp vec2 vL;\n  varying highp vec2 vR;\n  varying highp vec2 vT;\n  varying highp vec2 vB;\n  uniform sampler2D uPressure;\n  uniform sampler2D uDivergence;\n\n  void main () {\n    float L = texture2D(uPressure, vL).x;\n    float R = texture2D(uPressure, vR).x;\n    float T = texture2D(uPressure, vT).x;\n    float B = texture2D(uPressure, vB).x;\n    float C = texture2D(uPressure, vUv).x;\n    float divergence = texture2D(uDivergence, vUv).x;\n    float pressure = (L + R + B + T - divergence) * 0.25;\n    gl_FragColor = vec4(pressure, 0.0, 0.0, 1.0);\n  }\n";
var $24b01363b51bd19a$var$gradientSubtractShader = "\n  precision mediump float;\n  precision mediump sampler2D;\n  varying highp vec2 vUv;\n  varying highp vec2 vL;\n  varying highp vec2 vR;\n  varying highp vec2 vT;\n  varying highp vec2 vB;\n  uniform sampler2D uPressure;\n  uniform sampler2D uVelocity;\n\n  void main () {\n    float L = texture2D(uPressure, vL).x;\n    float R = texture2D(uPressure, vR).x;\n    float T = texture2D(uPressure, vT).x;\n    float B = texture2D(uPressure, vB).x;\n    vec2 velocity = texture2D(uVelocity, vUv).xy;\n    velocity.xy -= vec2(R - L, T - B);\n    gl_FragColor = vec4(velocity, 0.0, 1.0);\n  }\n";
var $24b01363b51bd19a$var$FluidSimulation = /*#__PURE__*/ function() {
    "use strict";
    function FluidSimulation(container) {
        var _this = this;
        (0, $bf2e53ae99fda9f5$export$71511d61b312f219)(this, FluidSimulation);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "canvas", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "gl", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "ext", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "pointers", []);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "splatStack", []);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "programs", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "dye", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "velocity", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "divergence", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "curl", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "pressure", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "blit", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "animationId", 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "lastUpdateTime", 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "isVisible", false);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "resizeObserver", null);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "intersectionObserver", null);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "container", void 0);
        (0, $2b1f4dace316f7be$export$71511d61b312f219)(this, "update", function() {
            if (!_this.isVisible) {
                _this.animationId = 0;
                return;
            }
            var dt = _this.calcDeltaTime();
            _this.step(dt);
            _this.render();
            _this.animationId = requestAnimationFrame(_this.update);
        });
        this.container = container;
        // Create canvas
        this.canvas = document.createElement('canvas');
        this.canvas.style.cssText = "\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      pointer-events: none;\n      z-index: 0;\n    ";
        container.style.position = 'relative';
        container.insertBefore(this.canvas, container.firstChild);
        // Get WebGL context
        var params = {
            alpha: true,
            depth: false,
            stencil: false,
            antialias: false,
            preserveDrawingBuffer: false
        };
        this.gl = this.canvas.getContext('webgl', params) || this.canvas.getContext('experimental-webgl', params);
        if (!this.gl) {
            console.warn('[FluidSimulation] WebGL not supported');
            return;
        }
        // Get extensions
        this.ext = this.getWebGLExtensions();
        // Compile shaders
        this.programs = {
            clear: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$clearShader),
            display: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$displayShader),
            splat: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$splatShader),
            advection: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$advectionShader),
            divergence: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$divergenceShader),
            curl: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$curlShader),
            vorticity: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$vorticityShader),
            pressure: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$pressureShader),
            gradientSubtract: this.createProgram($24b01363b51bd19a$var$baseVertexShader, $24b01363b51bd19a$var$gradientSubtractShader)
        };
        // Create blit function
        this.blit = this.createBlitFunction();
        // Initialize framebuffers
        this.initFramebuffers();
        // Initialize pointer
        this.pointers.push(this.createPointer());
        // Setup event listeners
        this.setupEventListeners();
        // Setup observers
        this.resizeObserver = new ResizeObserver(function() {
            return _this.resize();
        });
        this.resizeObserver.observe(container);
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            _this.isVisible = entries[0].isIntersecting;
            if (_this.isVisible && !_this.animationId) {
                _this.lastUpdateTime = Date.now();
                _this.update();
            }
        }, {
            threshold: 0
        });
        this.intersectionObserver.observe(container);
        // Initial setup
        this.resize();
        this.lastUpdateTime = Date.now();
        // Start animation
        this.update();
        console.log('[FluidSimulation] Initialized successfully');
    }
    (0, $ac98c22c37821d14$export$71511d61b312f219)(FluidSimulation, [
        {
            key: "getWebGLExtensions",
            value: function getWebGLExtensions() {
                var _gl_getExtension;
                var gl = this.gl;
                gl.getExtension('OES_texture_half_float');
                gl.getExtension('OES_texture_half_float_linear');
                var halfFloatTexType = ((_gl_getExtension = gl.getExtension('OES_texture_half_float')) === null || _gl_getExtension === void 0 ? void 0 : _gl_getExtension.HALF_FLOAT_OES) || gl.UNSIGNED_BYTE;
                var formatRGBA = {
                    internalFormat: gl.RGBA,
                    format: gl.RGBA
                };
                var formatRG = {
                    internalFormat: gl.RGBA,
                    format: gl.RGBA
                };
                var formatR = {
                    internalFormat: gl.RGBA,
                    format: gl.RGBA
                };
                var supportLinearFiltering = !!gl.getExtension('OES_texture_half_float_linear');
                return {
                    formatRGBA: formatRGBA,
                    formatRG: formatRG,
                    formatR: formatR,
                    halfFloatTexType: halfFloatTexType,
                    supportLinearFiltering: supportLinearFiltering
                };
            }
        },
        {
            key: "createProgram",
            value: function createProgram(vertexSource, fragmentSource) {
                var gl = this.gl;
                var vertexShader = gl.createShader(gl.VERTEX_SHADER);
                gl.shaderSource(vertexShader, vertexSource);
                gl.compileShader(vertexShader);
                var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
                gl.shaderSource(fragmentShader, fragmentSource);
                gl.compileShader(fragmentShader);
                var program = gl.createProgram();
                gl.attachShader(program, vertexShader);
                gl.attachShader(program, fragmentShader);
                gl.linkProgram(program);
                var uniforms = {};
                var uniformCount = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
                for(var i = 0; i < uniformCount; i++){
                    var uniformName = gl.getActiveUniform(program, i).name;
                    uniforms[uniformName] = gl.getUniformLocation(program, uniformName);
                }
                return {
                    program: program,
                    uniforms: uniforms,
                    bind: function() {
                        return gl.useProgram(program);
                    }
                };
            }
        },
        {
            key: "createBlitFunction",
            value: function createBlitFunction() {
                var gl = this.gl;
                var buffer = gl.createBuffer();
                gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
                    -1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    1,
                    -1
                ]), gl.STATIC_DRAW);
                var indexBuffer = gl.createBuffer();
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
                gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([
                    0,
                    1,
                    2,
                    0,
                    2,
                    3
                ]), gl.STATIC_DRAW);
                gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
                gl.enableVertexAttribArray(0);
                return function(target) {
                    var clear = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    if (target === null) {
                        gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    } else {
                        gl.viewport(0, 0, target.width, target.height);
                        gl.bindFramebuffer(gl.FRAMEBUFFER, target.fbo);
                    }
                    if (clear) {
                        gl.clearColor(0, 0, 0, 0);
                        gl.clear(gl.COLOR_BUFFER_BIT);
                    }
                    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
                };
            }
        },
        {
            key: "createFBO",
            value: function createFBO(w, h, internalFormat, format, type, filter) {
                var gl = this.gl;
                gl.activeTexture(gl.TEXTURE0);
                var texture = gl.createTexture();
                gl.bindTexture(gl.TEXTURE_2D, texture);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filter);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filter);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, w, h, 0, format, type, null);
                var fbo = gl.createFramebuffer();
                gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
                gl.viewport(0, 0, w, h);
                gl.clear(gl.COLOR_BUFFER_BIT);
                var texelSizeX = 1.0 / w;
                var texelSizeY = 1.0 / h;
                return {
                    texture: texture,
                    fbo: fbo,
                    width: w,
                    height: h,
                    texelSizeX: texelSizeX,
                    texelSizeY: texelSizeY,
                    attach: function(id) {
                        gl.activeTexture(gl.TEXTURE0 + id);
                        gl.bindTexture(gl.TEXTURE_2D, texture);
                        return id;
                    }
                };
            }
        },
        {
            key: "createDoubleFBO",
            value: function createDoubleFBO(w, h, internalFormat, format, type, filter) {
                var fbo1 = this.createFBO(w, h, internalFormat, format, type, filter);
                var fbo2 = this.createFBO(w, h, internalFormat, format, type, filter);
                return {
                    width: w,
                    height: h,
                    texelSizeX: fbo1.texelSizeX,
                    texelSizeY: fbo1.texelSizeY,
                    get read () {
                        return fbo1;
                    },
                    set read (value){
                        fbo1 = value;
                    },
                    get write () {
                        return fbo2;
                    },
                    set write (value){
                        fbo2 = value;
                    },
                    swap: function() {
                        var temp = fbo1;
                        fbo1 = fbo2;
                        fbo2 = temp;
                    }
                };
            }
        },
        {
            key: "initFramebuffers",
            value: function initFramebuffers() {
                var gl = this.gl;
                var simRes = this.getResolution($24b01363b51bd19a$var$config.SIM_RESOLUTION);
                var dyeRes = this.getResolution($24b01363b51bd19a$var$config.DYE_RESOLUTION);
                var texType = this.ext.halfFloatTexType;
                var rgba = this.ext.formatRGBA;
                var filtering = this.ext.supportLinearFiltering ? gl.LINEAR : gl.NEAREST;
                this.dye = this.createDoubleFBO(dyeRes.width, dyeRes.height, rgba.internalFormat, rgba.format, texType, filtering);
                this.velocity = this.createDoubleFBO(simRes.width, simRes.height, rgba.internalFormat, rgba.format, texType, filtering);
                this.divergence = this.createFBO(simRes.width, simRes.height, rgba.internalFormat, rgba.format, texType, gl.NEAREST);
                this.curl = this.createFBO(simRes.width, simRes.height, rgba.internalFormat, rgba.format, texType, gl.NEAREST);
                this.pressure = this.createDoubleFBO(simRes.width, simRes.height, rgba.internalFormat, rgba.format, texType, gl.NEAREST);
            }
        },
        {
            key: "getResolution",
            value: function getResolution(resolution) {
                var aspectRatio = this.gl.drawingBufferWidth / this.gl.drawingBufferHeight;
                if (aspectRatio < 1) aspectRatio = 1.0 / aspectRatio;
                var min = Math.round(resolution);
                var max = Math.round(resolution * aspectRatio);
                if (this.gl.drawingBufferWidth > this.gl.drawingBufferHeight) return {
                    width: max,
                    height: min
                };
                else return {
                    width: min,
                    height: max
                };
            }
        },
        {
            key: "createPointer",
            value: function createPointer() {
                return {
                    id: -1,
                    texcoordX: 0,
                    texcoordY: 0,
                    prevTexcoordX: 0,
                    prevTexcoordY: 0,
                    deltaX: 0,
                    deltaY: 0,
                    down: false,
                    moved: false
                };
            }
        },
        {
            key: "setupEventListeners",
            value: function setupEventListeners() {
                // Use the container for pointer events, but canvas shows the effect
                this.container.style.pointerEvents = 'auto';
                this.container.addEventListener('mousemove', this.handleMouseMove.bind(this));
                this.container.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
                this.container.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
                this.container.addEventListener('touchmove', this.handleTouchMove.bind(this), {
                    passive: true
                });
                this.container.addEventListener('touchstart', this.handleTouchStart.bind(this), {
                    passive: true
                });
                this.container.addEventListener('touchend', this.handleTouchEnd.bind(this));
            }
        },
        {
            key: "handleMouseMove",
            value: function handleMouseMove(e) {
                var rect = this.canvas.getBoundingClientRect();
                var pointer = this.pointers[0];
                pointer.prevTexcoordX = pointer.texcoordX;
                pointer.prevTexcoordY = pointer.texcoordY;
                pointer.texcoordX = (e.clientX - rect.left) / rect.width;
                pointer.texcoordY = 1.0 - (e.clientY - rect.top) / rect.height;
                pointer.deltaX = pointer.texcoordX - pointer.prevTexcoordX;
                pointer.deltaY = pointer.texcoordY - pointer.prevTexcoordY;
                pointer.moved = Math.abs(pointer.deltaX) > 0 || Math.abs(pointer.deltaY) > 0;
            }
        },
        {
            key: "handleMouseEnter",
            value: function handleMouseEnter(e) {
                var rect = this.canvas.getBoundingClientRect();
                var pointer = this.pointers[0];
                pointer.down = true;
                pointer.texcoordX = (e.clientX - rect.left) / rect.width;
                pointer.texcoordY = 1.0 - (e.clientY - rect.top) / rect.height;
                pointer.prevTexcoordX = pointer.texcoordX;
                pointer.prevTexcoordY = pointer.texcoordY;
            }
        },
        {
            key: "handleMouseLeave",
            value: function handleMouseLeave() {
                this.pointers[0].down = false;
            }
        },
        {
            key: "handleTouchStart",
            value: function handleTouchStart(e) {
                var touches = e.targetTouches;
                var rect = this.canvas.getBoundingClientRect();
                for(var i = 0; i < touches.length; i++){
                    if (i >= this.pointers.length) this.pointers.push(this.createPointer());
                    var pointer = this.pointers[i];
                    pointer.id = touches[i].identifier;
                    pointer.down = true;
                    pointer.texcoordX = (touches[i].clientX - rect.left) / rect.width;
                    pointer.texcoordY = 1.0 - (touches[i].clientY - rect.top) / rect.height;
                    pointer.prevTexcoordX = pointer.texcoordX;
                    pointer.prevTexcoordY = pointer.texcoordY;
                }
            }
        },
        {
            key: "handleTouchMove",
            value: function handleTouchMove(e) {
                var _this, _loop = function(i) {
                    var pointer = _this.pointers.find(function(p) {
                        return p.id === touches[i].identifier;
                    });
                    if (!pointer) return "continue";
                    pointer.prevTexcoordX = pointer.texcoordX;
                    pointer.prevTexcoordY = pointer.texcoordY;
                    pointer.texcoordX = (touches[i].clientX - rect.left) / rect.width;
                    pointer.texcoordY = 1.0 - (touches[i].clientY - rect.top) / rect.height;
                    pointer.deltaX = pointer.texcoordX - pointer.prevTexcoordX;
                    pointer.deltaY = pointer.texcoordY - pointer.prevTexcoordY;
                    pointer.moved = Math.abs(pointer.deltaX) > 0 || Math.abs(pointer.deltaY) > 0;
                };
                var touches = e.targetTouches;
                var rect = this.canvas.getBoundingClientRect();
                for(var i = 0; i < touches.length; i++)_this = this, _loop(i);
            }
        },
        {
            key: "handleTouchEnd",
            value: function handleTouchEnd(e) {
                var _this, _loop = function(i) {
                    var pointer = _this.pointers.find(function(p) {
                        return p.id === touches[i].identifier;
                    });
                    if (pointer) pointer.down = false;
                };
                var touches = e.changedTouches;
                for(var i = 0; i < touches.length; i++)_this = this, _loop(i);
            }
        },
        {
            key: "resize",
            value: function resize() {
                var dpr = Math.min(window.devicePixelRatio, 2);
                var width = Math.floor(this.canvas.clientWidth * dpr);
                var height = Math.floor(this.canvas.clientHeight * dpr);
                if (this.canvas.width !== width || this.canvas.height !== height) {
                    this.canvas.width = width;
                    this.canvas.height = height;
                    this.initFramebuffers();
                }
            }
        },
        {
            key: "calcDeltaTime",
            value: function calcDeltaTime() {
                var now = Date.now();
                var dt = (now - this.lastUpdateTime) / 1000;
                dt = Math.min(dt, 0.016666);
                this.lastUpdateTime = now;
                return dt;
            }
        },
        {
            key: "step",
            value: function step(dt) {
                var _this = this;
                var gl = this.gl;
                gl.disable(gl.BLEND);
                // Handle splats from pointer movement
                this.pointers.forEach(function(pointer) {
                    if (pointer.moved) {
                        pointer.moved = false;
                        var dx = pointer.deltaX * $24b01363b51bd19a$var$config.SPLAT_FORCE;
                        var dy = pointer.deltaY * $24b01363b51bd19a$var$config.SPLAT_FORCE;
                        _this.splat(pointer.texcoordX, pointer.texcoordY, dx, dy, $24b01363b51bd19a$var$config.COLOR);
                    }
                });
                // Curl
                this.programs.curl.bind();
                gl.uniform2f(this.programs.curl.uniforms['texelSize'], this.velocity.texelSizeX, this.velocity.texelSizeY);
                gl.uniform1i(this.programs.curl.uniforms['uVelocity'], this.velocity.read.attach(0));
                this.blit(this.curl);
                // Vorticity
                this.programs.vorticity.bind();
                gl.uniform2f(this.programs.vorticity.uniforms['texelSize'], this.velocity.texelSizeX, this.velocity.texelSizeY);
                gl.uniform1i(this.programs.vorticity.uniforms['uVelocity'], this.velocity.read.attach(0));
                gl.uniform1i(this.programs.vorticity.uniforms['uCurl'], this.curl.attach(1));
                gl.uniform1f(this.programs.vorticity.uniforms['curl'], $24b01363b51bd19a$var$config.CURL);
                gl.uniform1f(this.programs.vorticity.uniforms['dt'], dt);
                this.blit(this.velocity.write);
                this.velocity.swap();
                // Divergence
                this.programs.divergence.bind();
                gl.uniform2f(this.programs.divergence.uniforms['texelSize'], this.velocity.texelSizeX, this.velocity.texelSizeY);
                gl.uniform1i(this.programs.divergence.uniforms['uVelocity'], this.velocity.read.attach(0));
                this.blit(this.divergence);
                // Clear pressure
                this.programs.clear.bind();
                gl.uniform1i(this.programs.clear.uniforms['uTexture'], this.pressure.read.attach(0));
                gl.uniform1f(this.programs.clear.uniforms['value'], 0.8);
                this.blit(this.pressure.write);
                this.pressure.swap();
                // Pressure iterations
                this.programs.pressure.bind();
                gl.uniform2f(this.programs.pressure.uniforms['texelSize'], this.velocity.texelSizeX, this.velocity.texelSizeY);
                gl.uniform1i(this.programs.pressure.uniforms['uDivergence'], this.divergence.attach(0));
                for(var i = 0; i < $24b01363b51bd19a$var$config.PRESSURE_ITERATIONS; i++){
                    gl.uniform1i(this.programs.pressure.uniforms['uPressure'], this.pressure.read.attach(1));
                    this.blit(this.pressure.write);
                    this.pressure.swap();
                }
                // Gradient subtract
                this.programs.gradientSubtract.bind();
                gl.uniform2f(this.programs.gradientSubtract.uniforms['texelSize'], this.velocity.texelSizeX, this.velocity.texelSizeY);
                gl.uniform1i(this.programs.gradientSubtract.uniforms['uPressure'], this.pressure.read.attach(0));
                gl.uniform1i(this.programs.gradientSubtract.uniforms['uVelocity'], this.velocity.read.attach(1));
                this.blit(this.velocity.write);
                this.velocity.swap();
                // Advect velocity
                this.programs.advection.bind();
                gl.uniform2f(this.programs.advection.uniforms['texelSize'], this.velocity.texelSizeX, this.velocity.texelSizeY);
                gl.uniform1i(this.programs.advection.uniforms['uVelocity'], this.velocity.read.attach(0));
                gl.uniform1i(this.programs.advection.uniforms['uSource'], this.velocity.read.attach(0));
                gl.uniform1f(this.programs.advection.uniforms['dt'], dt);
                gl.uniform1f(this.programs.advection.uniforms['dissipation'], $24b01363b51bd19a$var$config.VELOCITY_DISSIPATION);
                this.blit(this.velocity.write);
                this.velocity.swap();
                // Advect dye
                gl.uniform1i(this.programs.advection.uniforms['uVelocity'], this.velocity.read.attach(0));
                gl.uniform1i(this.programs.advection.uniforms['uSource'], this.dye.read.attach(1));
                gl.uniform1f(this.programs.advection.uniforms['dissipation'], $24b01363b51bd19a$var$config.DENSITY_DISSIPATION);
                this.blit(this.dye.write);
                this.dye.swap();
            }
        },
        {
            key: "splat",
            value: function splat(x, y, dx, dy, color) {
                var gl = this.gl;
                this.programs.splat.bind();
                gl.uniform1i(this.programs.splat.uniforms['uTarget'], this.velocity.read.attach(0));
                gl.uniform1f(this.programs.splat.uniforms['aspectRatio'], this.canvas.width / this.canvas.height);
                gl.uniform2f(this.programs.splat.uniforms['point'], x, y);
                gl.uniform4f(this.programs.splat.uniforms['color'], dx, dy, 0.0, 1.0);
                gl.uniform1f(this.programs.splat.uniforms['radius'], this.correctRadius($24b01363b51bd19a$var$config.SPLAT_RADIUS / 100.0));
                this.blit(this.velocity.write);
                this.velocity.swap();
                gl.uniform1i(this.programs.splat.uniforms['uTarget'], this.dye.read.attach(0));
                gl.uniform4f(this.programs.splat.uniforms['color'], color.r, color.g, color.b, color.a);
                this.blit(this.dye.write);
                this.dye.swap();
            }
        },
        {
            key: "correctRadius",
            value: function correctRadius(radius) {
                var aspectRatio = this.canvas.width / this.canvas.height;
                if (aspectRatio > 1) return radius * aspectRatio;
                return radius;
            }
        },
        {
            key: "render",
            value: function render() {
                var gl = this.gl;
                gl.enable(gl.BLEND);
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
                this.programs.display.bind();
                gl.uniform1i(this.programs.display.uniforms['uTexture'], this.dye.read.attach(0));
                this.blit(null, true);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.animationId) cancelAnimationFrame(this.animationId);
                if (this.resizeObserver) this.resizeObserver.disconnect();
                if (this.intersectionObserver) this.intersectionObserver.disconnect();
                if (this.canvas && this.canvas.parentNode) this.canvas.parentNode.removeChild(this.canvas);
            }
        }
    ]);
    return FluidSimulation;
}();
function $24b01363b51bd19a$export$21339d51946d3609() {
    var container = document.querySelector('[data-footer-shader]');
    if (container) new $24b01363b51bd19a$var$FluidSimulation(container);
}
// Auto-init
if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $24b01363b51bd19a$export$21339d51946d3609);
    else $24b01363b51bd19a$export$21339d51946d3609();
}
var $24b01363b51bd19a$export$2e2bcd8739ae039 = $24b01363b51bd19a$var$FluidSimulation;


/**
 * Values Section Scroll Animation
 *
 * Dynamically handles values from the CMS.
 * Reads the count from data-values-count attribute.
 *
 * Scroll sequence (1 step per value):
 * - Step 0 (default): Show value 1, all layers violet
 * - Step 1: Show value 2, layer 1 (inner) lights up white
 * - Step 2: Show value 3, layer 2 (middle) lights up white
 * - Step 3: Show value 4, layer 3 (outer) lights up white
 * - Step 4: Show value 5, layers connect (rotate layer 2)
 */ var $fcaf52c06ad2e684$export$68c286be0e7e55b7 = function() {
    var section = document.getElementById('js-values');
    if (!section) {
        console.log('[Values] Section #js-values not found');
        return;
    }
    console.log('[Values] Initializing scroll animation');
    // Get the number of values from data attribute
    var valuesCount = parseInt(section.dataset.valuesCount || '0', 10);
    if (valuesCount === 0) {
        console.log('[Values] No values found');
        return;
    }
    console.log("[Values] Found ".concat(valuesCount, " values"));
    // Get value elements dynamically
    var valuesArray = [];
    for(var i = 1; i <= valuesCount; i++){
        var valueEl = document.getElementById("value-".concat(i));
        if (valueEl) valuesArray.push(valueEl);
    }
    if (valuesArray.length !== valuesCount) {
        console.log('[Values] Not all value elements found', {
            expected: valuesCount,
            found: valuesArray.length
        });
        return;
    }
    // Get logomark layers
    var layer1 = document.getElementById('logomark-layer-1');
    var layer2 = document.getElementById('logomark-layer-2');
    var layer3 = document.getElementById('logomark-layer-3');
    if (!layer1 || !layer2 || !layer3) {
        console.log('[Values] Logomark layers not found');
        return;
    }
    // Get scroll indicator
    var scrollIndicator = document.getElementById('values-scroll-indicator');
    console.log('[Values] All elements found');
    // Colors
    var violetColor = 'rgb(var(--color-violet))';
    var whiteColor = 'rgb(var(--color-white))';
    // One step per value
    var totalSteps = valuesCount;
    // Track state
    var lastStep = -1;
    var update = function() {
        var rect = section.getBoundingClientRect();
        var scrollContainer = section.querySelector('div');
        if (!scrollContainer) return;
        var containerHeight = scrollContainer.offsetHeight;
        var viewportHeight = window.innerHeight;
        // How far the section top is above the viewport top (positive = scrolled past)
        var scrolled = -rect.top;
        // Total scrollable distance within this section
        var maxScroll = containerHeight - viewportHeight;
        // Progress 0-1
        var progress = Math.max(0, Math.min(1, scrolled / maxScroll));
        // Fade out scroll indicator based on progress
        if (scrollIndicator) {
            if (progress > 0.05) scrollIndicator.style.opacity = Math.max(0, 1 - progress * 3).toString();
            else scrollIndicator.style.opacity = '1';
        }
        // Calculate current step (one per value)
        var step = Math.min(totalSteps - 1, Math.floor(progress * totalSteps));
        // Only update on step change
        if (step === lastStep) return;
        lastStep = step;
        console.log("[Values] Step: ".concat(step, ", Progress: ").concat(progress.toFixed(2)));
        // Reset all values to hidden
        valuesArray.forEach(function(value) {
            value.style.opacity = '0';
            value.style.pointerEvents = 'none';
        });
        // Reset all layers to violet
        layer1.style.color = violetColor;
        layer2.style.color = violetColor;
        layer3.style.color = violetColor;
        // Reset layer 2 rotation
        layer2.style.transform = 'rotate(0deg)';
        // Show active value
        valuesArray[step].style.opacity = '1';
        valuesArray[step].style.pointerEvents = 'auto';
        // Step 1: Layer 1 (inner) lights up
        if (step >= 1) layer1.style.color = whiteColor;
        // Step 2: Layer 2 (middle) lights up
        if (step >= 2) layer2.style.color = whiteColor;
        // Step 3: Layer 3 (outer) lights up
        if (step >= 3) layer3.style.color = whiteColor;
        // Step 4: Layers connect — rotate layer 2
        if (step >= 4) layer2.style.transform = 'rotate(15deg)';
    };
    // Scroll listener with RAF throttle
    var ticking = false;
    var onScroll = function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                update();
                ticking = false;
            });
            ticking = true;
        }
    };
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
    // Initial update
    update();
    console.log('[Values] Animation ready');
};


function $0067abc1dfa9ab4c$export$1117968d46e6cacc() {
    var header = document.getElementById('site-header');
    if (!header) return;
    var lastScrollY = 0;
    var ticking = false;
    var deadZone = 10;
    var hideThreshold = 100;
    var update = function() {
        var currentScrollY = window.scrollY;
        // Add/remove scrolled state for backdrop blur
        if (currentScrollY > 10) header.classList.add('header-scrolled');
        else header.classList.remove('header-scrolled');
        // Don't hide/show when mobile nav is open
        if (document.body.classList.contains('nav-open')) {
            lastScrollY = currentScrollY;
            ticking = false;
            return;
        }
        var delta = currentScrollY - lastScrollY;
        // Dead zone — ignore small scroll movements
        if (Math.abs(delta) < deadZone) {
            ticking = false;
            return;
        }
        // Scrolling down past threshold — hide
        if (delta > 0 && currentScrollY > hideThreshold) header.classList.add('header-hidden');
        // Scrolling up — show
        if (delta < 0) header.classList.remove('header-hidden');
        lastScrollY = currentScrollY;
        ticking = false;
    };
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }, {
        passive: true
    });
}
function $0067abc1dfa9ab4c$export$7cb32b21c01a8e9a() {
    var hamburger = document.getElementById('hamburger');
    var nav = document.getElementById('mobile-nav');
    if (!hamburger || !nav) return;
    var hamburgerParent = hamburger.closest('body > *');
    var isOpen = false;
    function openNav() {
        isOpen = true;
        hamburger.classList.add('is-active');
        nav.classList.add('is-open');
        nav.setAttribute('aria-hidden', 'false');
        hamburger.setAttribute('aria-expanded', 'true');
        hamburger.setAttribute('aria-label', 'Close menu');
        document.body.classList.add('nav-open');
        document.body.style.overflow = 'hidden';
        // Make rest of page inert to prevent focus escaping
        document.querySelectorAll('body > *:not(#mobile-nav)').forEach(function(el) {
            if (el instanceof HTMLElement && el !== hamburgerParent) {
                el.setAttribute('inert', '');
                el.setAttribute('aria-hidden', 'true');
            }
        });
        // Focus the first nav link
        var firstLink = nav.querySelector('.mobile-nav-link');
        firstLink === null || firstLink === void 0 ? void 0 : firstLink.focus();
    }
    function closeNav() {
        isOpen = false;
        hamburger.classList.remove('is-active');
        nav.classList.remove('is-open');
        nav.setAttribute('aria-hidden', 'true');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', 'Open menu');
        document.body.classList.remove('nav-open');
        document.body.style.overflow = '';
        // Remove inert from rest of page
        document.querySelectorAll('body > *:not(#mobile-nav)').forEach(function(el) {
            if (el instanceof HTMLElement && el !== hamburgerParent) {
                el.removeAttribute('inert');
                el.removeAttribute('aria-hidden');
            }
        });
        // Return focus to the hamburger button
        hamburger.focus();
    }
    var toggleNav = function() {
        return isOpen ? closeNav() : openNav();
    };
    // Toggle on hamburger click
    hamburger.addEventListener('click', toggleNav);
    // Close on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isOpen) closeNav();
    });
}


function $c739b48b50fc7fc1$export$71511d61b312f219(o) {
    $c739b48b50fc7fc1$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c739b48b50fc7fc1$export$71511d61b312f219(o);
}


function $17eca7540878dcc2$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($17eca7540878dcc2$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $bc4a9dcaad5d53e6$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $3911bfce698fbe4a$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $9441b8b98c5bba2b$export$71511d61b312f219(self, call) {
    if (call && ((0, $3911bfce698fbe4a$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $bc4a9dcaad5d53e6$export$71511d61b312f219)(self);
}


function $27fc2d546b8e5514$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $c739b48b50fc7fc1$export$71511d61b312f219)(derived);
    return (0, $9441b8b98c5bba2b$export$71511d61b312f219)(_this, (0, $17eca7540878dcc2$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $c739b48b50fc7fc1$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}





function $93bfc7cac5034a4d$export$71511d61b312f219(o, p) {
    $93bfc7cac5034a4d$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $93bfc7cac5034a4d$export$71511d61b312f219(o, p);
}


function $5ddaf6e638d3c6b1$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $93bfc7cac5034a4d$export$71511d61b312f219)(subClass, superClass);
}


function $4373a2021ce9f24e$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $3ccfc551bc3797a6$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $c3e63dd72629c443$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c2cfeed658375ef3$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $986d7e027c46ac1a$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c2cfeed658375ef3$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c2cfeed658375ef3$export$71511d61b312f219)(o, minLen);
}


function $c6938abc98c6418f$export$71511d61b312f219(arr, i) {
    return (0, $4373a2021ce9f24e$export$71511d61b312f219)(arr) || (0, $3ccfc551bc3797a6$export$71511d61b312f219)(arr, i) || (0, $986d7e027c46ac1a$export$71511d61b312f219)(arr, i) || (0, $c3e63dd72629c443$export$71511d61b312f219)();
}




function $8a4c42fc3c545f08$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $17eca7540878dcc2$export$71511d61b312f219)()) $8a4c42fc3c545f08$export$71511d61b312f219 = Reflect.construct;
    else $8a4c42fc3c545f08$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $93bfc7cac5034a4d$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $8a4c42fc3c545f08$export$71511d61b312f219.apply(null, arguments);
}



function $4649ffe4c6bb69e1$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $2ad5a62b12ac1a0c$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $2ad5a62b12ac1a0c$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $4649ffe4c6bb69e1$export$71511d61b312f219)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $8a4c42fc3c545f08$export$71511d61b312f219)(Class, arguments, (0, $c739b48b50fc7fc1$export$71511d61b312f219)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $93bfc7cac5034a4d$export$71511d61b312f219)(Wrapper, Class);
    };
    return $2ad5a62b12ac1a0c$export$71511d61b312f219(Class);
}




var $13c8b89034f966ca$var$n, $13c8b89034f966ca$export$41c562ebe57d11e2, $13c8b89034f966ca$var$u, $13c8b89034f966ca$export$a8257692ac88316c, $13c8b89034f966ca$var$i, $13c8b89034f966ca$var$r, $13c8b89034f966ca$var$o, $13c8b89034f966ca$var$e, $13c8b89034f966ca$var$f, $13c8b89034f966ca$var$c, $13c8b89034f966ca$var$s, $13c8b89034f966ca$var$a, $13c8b89034f966ca$var$h, $13c8b89034f966ca$var$p = {}, $13c8b89034f966ca$var$v = [], $13c8b89034f966ca$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c8b89034f966ca$var$d = Array.isArray;
function $13c8b89034f966ca$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c8b89034f966ca$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c8b89034f966ca$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $13c8b89034f966ca$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $13c8b89034f966ca$var$m(l, e, i, r, null);
}
function $13c8b89034f966ca$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$13c8b89034f966ca$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $13c8b89034f966ca$export$41c562ebe57d11e2.vnode && $13c8b89034f966ca$export$41c562ebe57d11e2.vnode(e), e;
}
function $13c8b89034f966ca$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c8b89034f966ca$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c8b89034f966ca$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c8b89034f966ca$var$S(n, l) {
    if (null == l) return n.__ ? $13c8b89034f966ca$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c8b89034f966ca$var$S(n) : null;
}
function $13c8b89034f966ca$var$C(n) {
    if (n.__P && n.__d) {
        var u = n.__v, t = u.__e, i = [], r = [], o = $13c8b89034f966ca$var$w({}, u);
        o.__v = u.__v + 1, $13c8b89034f966ca$export$41c562ebe57d11e2.vnode && $13c8b89034f966ca$export$41c562ebe57d11e2.vnode(o), $13c8b89034f966ca$var$z(n.__P, o, u, n.__n, n.__P.namespaceURI, 32 & u.__u ? [
            t
        ] : null, i, null == t ? $13c8b89034f966ca$var$S(u) : t, !!(32 & u.__u), r), o.__v = u.__v, o.__.__k[o.__i] = o, $13c8b89034f966ca$var$V(i, o, r), u.__e = u.__ = null, o.__e != t && $13c8b89034f966ca$var$M(o);
    }
}
function $13c8b89034f966ca$var$M(n) {
    if (null != (n = n.__) && null != n.__c) return n.__e = n.__c.base = null, n.__k.some(function(l) {
        if (null != l && null != l.__e) return n.__e = n.__c.base = l.__e;
    }), $13c8b89034f966ca$var$M(n);
}
function $13c8b89034f966ca$var$$(n) {
    (!n.__d && (n.__d = !0) && $13c8b89034f966ca$var$i.push(n) && !$13c8b89034f966ca$var$I.__r++ || $13c8b89034f966ca$var$r != $13c8b89034f966ca$export$41c562ebe57d11e2.debounceRendering) && (($13c8b89034f966ca$var$r = $13c8b89034f966ca$export$41c562ebe57d11e2.debounceRendering) || $13c8b89034f966ca$var$o)($13c8b89034f966ca$var$I);
}
function $13c8b89034f966ca$var$I() {
    for(var n, l = 1; $13c8b89034f966ca$var$i.length;)$13c8b89034f966ca$var$i.length > l && $13c8b89034f966ca$var$i.sort($13c8b89034f966ca$var$e), n = $13c8b89034f966ca$var$i.shift(), l = $13c8b89034f966ca$var$i.length, $13c8b89034f966ca$var$C(n);
    $13c8b89034f966ca$var$I.__r = 0;
}
function $13c8b89034f966ca$var$P(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, d, w, g, _, m = t && t.__k || $13c8b89034f966ca$var$v, b = l.length;
    for(f = $13c8b89034f966ca$var$A(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 != y.__i && m[y.__i] || $13c8b89034f966ca$var$p, y.__i = a, g = $13c8b89034f966ca$var$z(n, y, h, i, r, o, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $13c8b89034f966ca$var$D(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $13c8b89034f966ca$var$H(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $13c8b89034f966ca$var$A(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == (typeof o === "undefined" ? "undefined" : (0, $3911bfce698fbe4a$export$71511d61b312f219)(o)) || o.constructor == String ? o = n.__k[r] = $13c8b89034f966ca$var$m(null, o, null, null, null) : $13c8b89034f966ca$var$d(o) ? o = n.__k[r] = $13c8b89034f966ca$var$m($13c8b89034f966ca$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? o = n.__k[r] = $13c8b89034f966ca$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $13c8b89034f966ca$var$T(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $13c8b89034f966ca$var$S(e)), $13c8b89034f966ca$var$E(e, e));
    return t;
}
function $13c8b89034f966ca$var$H(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $13c8b89034f966ca$var$H(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $13c8b89034f966ca$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $13c8b89034f966ca$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c8b89034f966ca$var$d(n) ? n.some(function(n) {
        $13c8b89034f966ca$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c8b89034f966ca$var$T(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $13c8b89034f966ca$var$j(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c8b89034f966ca$var$y.test(l) ? u : u + "px";
}
function $13c8b89034f966ca$var$F(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c8b89034f966ca$var$j(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $13c8b89034f966ca$var$j(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($13c8b89034f966ca$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $13c8b89034f966ca$var$c, n.addEventListener(l, r ? $13c8b89034f966ca$var$a : $13c8b89034f966ca$var$s, r)) : n.removeEventListener(l, r ? $13c8b89034f966ca$var$a : $13c8b89034f966ca$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c8b89034f966ca$var$O(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $13c8b89034f966ca$var$c++;
            else if (u.t < t.u) return;
            return t($13c8b89034f966ca$export$41c562ebe57d11e2.event ? $13c8b89034f966ca$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c8b89034f966ca$var$z(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, y, _, m, b, S, C, M, $, _$I, A, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $13c8b89034f966ca$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (S = u.props, C = "prototype" in T && T.prototype.render, M = (a = T.contextType) && i[a.__c], $ = a ? M ? M.props.value : a.__ : i, t.__c ? b = (h = u.__c = t.__c).__ = h.__E : (C ? u.__c = h = new T(S, $) : (u.__c = h = new $13c8b89034f966ca$export$16fa2f45be04daa8(S, $), h.constructor = T, h.render = $13c8b89034f966ca$var$G), M && M.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), C && null == h.__s && (h.__s = h.state), C && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c8b89034f966ca$var$w({}, h.__s)), $13c8b89034f966ca$var$w(h.__s, T.getDerivedStateFromProps(S, h.__s))), y = h.props, _ = h.state, h.__v = u, p) C && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), C && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (C && null == T.getDerivedStateFromProps && S !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(S, $), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(S, h.__s, $)) {
                u.__v != t.__v && (h.props = S, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $13c8b89034f966ca$var$v.push.apply(h.__h, h._sb), h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(S, h.__s, $), C && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(y, _, m);
            });
        }
        if (h.context = $, h.props = S, h.__P = n, h.__e = !1, _$I = $13c8b89034f966ca$export$41c562ebe57d11e2.__r, A = 0, C) h.state = h.__s, h.__d = !1, _$I && _$I(u), a = h.render(h.props, h.state, h.context), $13c8b89034f966ca$var$v.push.apply(h.__h, h._sb), h._sb = [];
        else do h.__d = !1, _$I && _$I(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c8b89034f966ca$var$w($13c8b89034f966ca$var$w({}, i), h.getChildContext())), C && !p && null != h.getSnapshotBeforeUpdate && (m = h.getSnapshotBeforeUpdate(y, _)), H = null != a && a.type === $13c8b89034f966ca$export$ffb0004e005737fa && null == a.key ? $13c8b89034f966ca$var$q(a.props.children) : a, f = $13c8b89034f966ca$var$P(n, $13c8b89034f966ca$var$d(H) ? H : [
            H
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), b && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(L = o.length; L--;)$13c8b89034f966ca$var$g(o[L]);
                $13c8b89034f966ca$var$N(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $13c8b89034f966ca$var$N(u);
        $13c8b89034f966ca$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $13c8b89034f966ca$var$B(t.__e, u, t, i, r, o, e, c, s);
    return (a = $13c8b89034f966ca$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $13c8b89034f966ca$var$N(n) {
    n && (n.__c && (n.__c.__e = !0), n.__k && n.__k.some($13c8b89034f966ca$var$N));
}
function $13c8b89034f966ca$var$V(n, u, t) {
    for(var i = 0; i < t.length; i++)$13c8b89034f966ca$var$D(t[i], t[++i], t[++i]);
    $13c8b89034f966ca$export$41c562ebe57d11e2.__c && $13c8b89034f966ca$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c8b89034f966ca$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c8b89034f966ca$var$q(n) {
    return "object" != (typeof n === "undefined" ? "undefined" : (0, $3911bfce698fbe4a$export$71511d61b312f219)(n)) || null == n || n.__b > 0 ? n : $13c8b89034f966ca$var$d(n) ? n.map($13c8b89034f966ca$var$q) : $13c8b89034f966ca$var$w({}, n);
}
function $13c8b89034f966ca$var$B(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, w, _, m, b = i.props || $13c8b89034f966ca$var$p, _$k = t.props, _$x = t.type;
    if ("svg" == _$x ? o = "http://www.w3.org/2000/svg" : "math" == _$x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!_$x && (_$x ? w.localName == _$x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == _$x) return document.createTextNode(_$k);
        u = document.createElementNS(o, _$x, _$k.is && _$k), c && ($13c8b89034f966ca$export$41c562ebe57d11e2.__m && $13c8b89034f966ca$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == _$x) b === _$k || c && u.data == _$k || (u.data = _$k);
    else {
        if (e = e && $13c8b89034f966ca$var$n.call(u.childNodes), !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)w = b[a], "dangerouslySetInnerHTML" == a ? v = w : "children" == a || a in _$k || "value" == a && "defaultValue" in _$k || "checked" == a && "defaultChecked" in _$k || $13c8b89034f966ca$var$F(u, a, null, w, o);
        for(a in _$k)w = _$k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? _ = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $13c8b89034f966ca$var$F(u, a, w, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $13c8b89034f966ca$var$P("template" == t.type ? u.content : u, $13c8b89034f966ca$var$d(y) ? y : [
            y
        ], t, i, r, "foreignObject" == _$x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $13c8b89034f966ca$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$13c8b89034f966ca$var$g(e[a]);
        c || (a = "value", "progress" == _$x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == _$x && !_ || "option" == _$x && _ != b[a]) && $13c8b89034f966ca$var$F(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $13c8b89034f966ca$var$F(u, a, m, b[a], o));
    }
    return u;
}
function $13c8b89034f966ca$var$D(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c8b89034f966ca$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c8b89034f966ca$var$E(n, u, t) {
    var i, r;
    if ($13c8b89034f966ca$export$41c562ebe57d11e2.unmount && $13c8b89034f966ca$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $13c8b89034f966ca$var$D(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c8b89034f966ca$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $13c8b89034f966ca$var$E(i[r], u, t || "function" != typeof n.type);
    t || $13c8b89034f966ca$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $13c8b89034f966ca$var$G(n, l, u) {
    return this.constructor(n, u);
}
function $13c8b89034f966ca$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $13c8b89034f966ca$export$41c562ebe57d11e2.__ && $13c8b89034f966ca$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $13c8b89034f966ca$var$z(t, u = (!r && i || t).__k = $13c8b89034f966ca$export$c8a8987d4410bf2d($13c8b89034f966ca$export$ffb0004e005737fa, null, [
        u
    ]), o || $13c8b89034f966ca$var$p, $13c8b89034f966ca$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $13c8b89034f966ca$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $13c8b89034f966ca$var$V(e, u, f);
}
function $13c8b89034f966ca$export$fa8d919ba61d84db(n, l) {
    $13c8b89034f966ca$export$b3890eb0ae9dca99(n, l, $13c8b89034f966ca$export$fa8d919ba61d84db);
}
function $13c8b89034f966ca$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $13c8b89034f966ca$var$w({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c8b89034f966ca$var$n.call(arguments, 2) : t), $13c8b89034f966ca$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $13c8b89034f966ca$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $13c8b89034f966ca$var$$(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var _$l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), _$l && _$l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $13c8b89034f966ca$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$13c8b89034f966ca$var$n = $13c8b89034f966ca$var$v.slice, $13c8b89034f966ca$export$41c562ebe57d11e2 = {
    __e: function __e(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c8b89034f966ca$var$u = 0, $13c8b89034f966ca$export$a8257692ac88316c = function t(n) {
    return null != n && void 0 === n.constructor;
}, $13c8b89034f966ca$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $13c8b89034f966ca$var$w({}, this.state), "function" == typeof n && (n = n($13c8b89034f966ca$var$w({}, u), this.props)), n && $13c8b89034f966ca$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $13c8b89034f966ca$var$$(this));
}, $13c8b89034f966ca$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c8b89034f966ca$var$$(this));
}, $13c8b89034f966ca$export$16fa2f45be04daa8.prototype.render = $13c8b89034f966ca$export$ffb0004e005737fa, $13c8b89034f966ca$var$i = [], $13c8b89034f966ca$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c8b89034f966ca$var$e = function e(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c8b89034f966ca$var$I.__r = 0, $13c8b89034f966ca$var$f = /(PointerCapture)$|Capture$/i, $13c8b89034f966ca$var$c = 0, $13c8b89034f966ca$var$s = $13c8b89034f966ca$var$O(!1), $13c8b89034f966ca$var$a = $13c8b89034f966ca$var$O(!0), $13c8b89034f966ca$var$h = 0;


var $be8386bd25ce61d4$var$t = /["&<]/;
function $be8386bd25ce61d4$var$n(r) {
    if (0 === r.length || !1 === $be8386bd25ce61d4$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $be8386bd25ce61d4$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $be8386bd25ce61d4$var$f = 0, $be8386bd25ce61d4$var$i = Array.isArray;
function $be8386bd25ce61d4$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$be8386bd25ce61d4$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $13c8b89034f966ca$export$41c562ebe57d11e2).vnode && (0, $13c8b89034f966ca$export$41c562ebe57d11e2).vnode(l), l;
}
function $be8386bd25ce61d4$export$45700d561b2268ac(r) {
    var t = $be8386bd25ce61d4$export$34b9dba7ce09269b((0, $13c8b89034f966ca$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $be8386bd25ce61d4$var$c = {}, $be8386bd25ce61d4$var$p = /[A-Z]/g;
function $be8386bd25ce61d4$export$991f6ffe102e5bac(e, t) {
    if ((0, $13c8b89034f966ca$export$41c562ebe57d11e2).attr) {
        var f = (0, $13c8b89034f966ca$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == (typeof r === "undefined" ? "undefined" : (0, $3911bfce698fbe4a$export$71511d61b312f219)(r)) && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == (typeof t === "undefined" ? "undefined" : (0, $3911bfce698fbe4a$export$71511d61b312f219)(t))) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $be8386bd25ce61d4$var$c[u] || ($be8386bd25ce61d4$var$c[u] = u.replace($be8386bd25ce61d4$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $be8386bd25ce61d4$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $be8386bd25ce61d4$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == (typeof t === "undefined" ? "undefined" : (0, $3911bfce698fbe4a$export$71511d61b312f219)(t)) ? "" : !0 === t ? e : e + '="' + $be8386bd25ce61d4$var$n("" + t) + '"';
}
function $be8386bd25ce61d4$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == (typeof r === "undefined" ? "undefined" : (0, $3911bfce698fbe4a$export$71511d61b312f219)(r))) {
        if (void 0 === r.constructor) return r;
        if ($be8386bd25ce61d4$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $be8386bd25ce61d4$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $be8386bd25ce61d4$var$n("" + r);
}




var $dcc8496ca7afa43a$var$t, $dcc8496ca7afa43a$var$r, $dcc8496ca7afa43a$var$u, $dcc8496ca7afa43a$var$i, $dcc8496ca7afa43a$var$o = 0, $dcc8496ca7afa43a$var$f = [], $dcc8496ca7afa43a$var$c = (0, $13c8b89034f966ca$export$41c562ebe57d11e2), $dcc8496ca7afa43a$var$e = $dcc8496ca7afa43a$var$c.__b, $dcc8496ca7afa43a$var$a = $dcc8496ca7afa43a$var$c.__r, $dcc8496ca7afa43a$var$v = $dcc8496ca7afa43a$var$c.diffed, $dcc8496ca7afa43a$var$l = $dcc8496ca7afa43a$var$c.__c, $dcc8496ca7afa43a$var$m = $dcc8496ca7afa43a$var$c.unmount, $dcc8496ca7afa43a$var$s = $dcc8496ca7afa43a$var$c.__;
function $dcc8496ca7afa43a$var$p(n, t) {
    $dcc8496ca7afa43a$var$c.__h && $dcc8496ca7afa43a$var$c.__h($dcc8496ca7afa43a$var$r, n, $dcc8496ca7afa43a$var$o || t), $dcc8496ca7afa43a$var$o = 0;
    var u = $dcc8496ca7afa43a$var$r.__H || ($dcc8496ca7afa43a$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $dcc8496ca7afa43a$export$60241385465d0a34(n) {
    return $dcc8496ca7afa43a$var$o = 1, $dcc8496ca7afa43a$export$13e3392192263954($dcc8496ca7afa43a$var$D, n);
}
function $dcc8496ca7afa43a$export$13e3392192263954(n, u, i) {
    var o = $dcc8496ca7afa43a$var$p($dcc8496ca7afa43a$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $dcc8496ca7afa43a$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $dcc8496ca7afa43a$var$r, !$dcc8496ca7afa43a$var$r.__f)) {
        var f = function f(n, t, r) {
            if (!o.__c.__H) return !0;
            var _$u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (_$u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var _$i = o.__c.props !== n;
            return _$u.some(function(n) {
                if (n.__N) {
                    var _$t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, _$t !== n.__[0] && (_$i = !0);
                }
            }), c && c.call(this, n, t, r) || _$i;
        };
        $dcc8496ca7afa43a$var$r.__f = !0;
        var c = $dcc8496ca7afa43a$var$r.shouldComponentUpdate, e = $dcc8496ca7afa43a$var$r.componentWillUpdate;
        $dcc8496ca7afa43a$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var _$u = c;
                c = void 0, f(n, t, r), c = _$u;
            }
            e && e.call(this, n, t, r);
        }, $dcc8496ca7afa43a$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $dcc8496ca7afa43a$export$6d9c69b0de29b591(n, u) {
    var i = $dcc8496ca7afa43a$var$p($dcc8496ca7afa43a$var$t++, 3);
    !$dcc8496ca7afa43a$var$c.__s && $dcc8496ca7afa43a$var$C(i.__H, u) && (i.__ = n, i.u = u, $dcc8496ca7afa43a$var$r.__H.__h.push(i));
}
function $dcc8496ca7afa43a$export$e5c5a5f917a5871c(n, u) {
    var i = $dcc8496ca7afa43a$var$p($dcc8496ca7afa43a$var$t++, 4);
    !$dcc8496ca7afa43a$var$c.__s && $dcc8496ca7afa43a$var$C(i.__H, u) && (i.__ = n, i.u = u, $dcc8496ca7afa43a$var$r.__h.push(i));
}
function $dcc8496ca7afa43a$export$b8f5890fc79d6aca(n) {
    return $dcc8496ca7afa43a$var$o = 5, $dcc8496ca7afa43a$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $dcc8496ca7afa43a$export$d5a552a76deda3c2(n, t, r) {
    $dcc8496ca7afa43a$var$o = 6, $dcc8496ca7afa43a$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var _$r = n(t());
            return function() {
                n(null), _$r && "function" == typeof _$r && _$r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $dcc8496ca7afa43a$export$1538c33de8887b59(n, r) {
    var u = $dcc8496ca7afa43a$var$p($dcc8496ca7afa43a$var$t++, 7);
    return $dcc8496ca7afa43a$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $dcc8496ca7afa43a$export$35808ee640e87ca7(n, t) {
    return $dcc8496ca7afa43a$var$o = 8, $dcc8496ca7afa43a$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $dcc8496ca7afa43a$export$fae74005e78b1a27(n) {
    var u = $dcc8496ca7afa43a$var$r.context[n.__c], i = $dcc8496ca7afa43a$var$p($dcc8496ca7afa43a$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($dcc8496ca7afa43a$var$r)), u.props.value) : n.__;
}
function $dcc8496ca7afa43a$export$dc8fbce3eb94dc1e(n, t) {
    $dcc8496ca7afa43a$var$c.useDebugValue && $dcc8496ca7afa43a$var$c.useDebugValue(t ? t(n) : n);
}
function $dcc8496ca7afa43a$export$c052f6604b7d51fe(n) {
    var u = $dcc8496ca7afa43a$var$p($dcc8496ca7afa43a$var$t++, 10), i = $dcc8496ca7afa43a$export$60241385465d0a34();
    return u.__ = n, $dcc8496ca7afa43a$var$r.componentDidCatch || ($dcc8496ca7afa43a$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $dcc8496ca7afa43a$export$f680877a34711e37() {
    var _$n = $dcc8496ca7afa43a$var$p($dcc8496ca7afa43a$var$t++, 11);
    if (!_$n.__) {
        for(var u = $dcc8496ca7afa43a$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        _$n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return _$n.__;
}
function $dcc8496ca7afa43a$var$j() {
    for(var _$n; _$n = $dcc8496ca7afa43a$var$f.shift();){
        var t = _$n.__H;
        if (_$n.__P && t) try {
            t.__h.some($dcc8496ca7afa43a$var$z), t.__h.some($dcc8496ca7afa43a$var$B), t.__h = [];
        } catch (r) {
            t.__h = [], $dcc8496ca7afa43a$var$c.__e(r, _$n.__v);
        }
    }
}
$dcc8496ca7afa43a$var$c.__b = function(n) {
    $dcc8496ca7afa43a$var$r = null, $dcc8496ca7afa43a$var$e && $dcc8496ca7afa43a$var$e(n);
}, $dcc8496ca7afa43a$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $dcc8496ca7afa43a$var$s && $dcc8496ca7afa43a$var$s(n, t);
}, $dcc8496ca7afa43a$var$c.__r = function(n) {
    $dcc8496ca7afa43a$var$a && $dcc8496ca7afa43a$var$a(n), $dcc8496ca7afa43a$var$t = 0;
    var i = ($dcc8496ca7afa43a$var$r = n.__c).__H;
    i && ($dcc8496ca7afa43a$var$u === $dcc8496ca7afa43a$var$r ? (i.__h = [], $dcc8496ca7afa43a$var$r.__h = [], i.__.some(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.some($dcc8496ca7afa43a$var$z), i.__h.some($dcc8496ca7afa43a$var$B), i.__h = [], $dcc8496ca7afa43a$var$t = 0)), $dcc8496ca7afa43a$var$u = $dcc8496ca7afa43a$var$r;
}, $dcc8496ca7afa43a$var$c.diffed = function(n) {
    $dcc8496ca7afa43a$var$v && $dcc8496ca7afa43a$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $dcc8496ca7afa43a$var$f.push(t) && $dcc8496ca7afa43a$var$i === $dcc8496ca7afa43a$var$c.requestAnimationFrame || (($dcc8496ca7afa43a$var$i = $dcc8496ca7afa43a$var$c.requestAnimationFrame) || $dcc8496ca7afa43a$var$w)($dcc8496ca7afa43a$var$j)), t.__H.__.some(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $dcc8496ca7afa43a$var$u = $dcc8496ca7afa43a$var$r = null;
}, $dcc8496ca7afa43a$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.some($dcc8496ca7afa43a$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $dcc8496ca7afa43a$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $dcc8496ca7afa43a$var$c.__e(r, n.__v);
        }
    }), $dcc8496ca7afa43a$var$l && $dcc8496ca7afa43a$var$l(n, t);
}, $dcc8496ca7afa43a$var$c.unmount = function(n) {
    $dcc8496ca7afa43a$var$m && $dcc8496ca7afa43a$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.some(function(n) {
        try {
            $dcc8496ca7afa43a$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $dcc8496ca7afa43a$var$c.__e(t, r.__v));
};
var $dcc8496ca7afa43a$var$k = "function" == typeof requestAnimationFrame;
function $dcc8496ca7afa43a$var$w(n) {
    var t, r = function r() {
        clearTimeout(u), $dcc8496ca7afa43a$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $dcc8496ca7afa43a$var$k && (t = requestAnimationFrame(r));
}
function $dcc8496ca7afa43a$var$z(n) {
    var t = $dcc8496ca7afa43a$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $dcc8496ca7afa43a$var$r = t;
}
function $dcc8496ca7afa43a$var$B(n) {
    var t = $dcc8496ca7afa43a$var$r;
    n.__c = n.__(), $dcc8496ca7afa43a$var$r = t;
}
function $dcc8496ca7afa43a$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $dcc8496ca7afa43a$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}





function $bb8b933278227e3b$var$g(n, t) {
    for(var _$e in t)n[_$e] = t[_$e];
    return n;
}
function $bb8b933278227e3b$var$E(n, t) {
    for(var _$e in n)if ("__source" !== _$e && !(_$e in t)) return !0;
    for(var _$r in t)if ("__source" !== _$r && n[_$r] !== t[_$r]) return !0;
    return !1;
}
function $bb8b933278227e3b$export$306c0aa65ff9ec16(n, t) {
    var _$e = t(), _$r = (0, $dcc8496ca7afa43a$export$60241385465d0a34)({
        t: {
            __: _$e,
            u: t
        }
    }), _$u = _$r[0].t, o = _$r[1];
    return (0, $dcc8496ca7afa43a$export$e5c5a5f917a5871c)(function() {
        _$u.__ = _$e, _$u.u = t, $bb8b933278227e3b$var$R(_$u) && o({
            t: _$u
        });
    }, [
        n,
        _$e,
        t
    ]), (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        return $bb8b933278227e3b$var$R(_$u) && o({
            t: _$u
        }), n(function() {
            $bb8b933278227e3b$var$R(_$u) && o({
                t: _$u
            });
        });
    }, [
        n
    ]), _$e;
}
function $bb8b933278227e3b$var$R(n) {
    try {
        return !((_$t = n.__) === (_$e = n.u()) && (0 !== _$t || 1 / _$t == 1 / _$e) || _$t != _$t && _$e != _$e);
    } catch (n) {
        return !0;
    }
    var _$t, _$e;
}
function $bb8b933278227e3b$export$7568632d0d33d16d(n) {
    n();
}
function $bb8b933278227e3b$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $bb8b933278227e3b$export$7b286972b8d8ccbf() {
    return [
        !1,
        $bb8b933278227e3b$export$7568632d0d33d16d
    ];
}
var $bb8b933278227e3b$export$aaabe4eda9ed9969 = (0, $dcc8496ca7afa43a$export$e5c5a5f917a5871c);
function $bb8b933278227e3b$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $bb8b933278227e3b$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var _$t = this.props.ref, _$r = _$t == n.ref;
        return !_$r && _$t && (_$t.call ? _$t(null) : _$t.current = null), e ? !e(this.props, n) || !_$r : $bb8b933278227e3b$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $13c8b89034f966ca$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
($bb8b933278227e3b$export$221d75b3f55bb0bd.prototype = new (0, $13c8b89034f966ca$export$16fa2f45be04daa8)).isPureReactComponent = !0, $bb8b933278227e3b$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $bb8b933278227e3b$var$E(this.props, n) || $bb8b933278227e3b$var$E(this.state, t);
};
var $bb8b933278227e3b$var$T = (0, $13c8b89034f966ca$export$41c562ebe57d11e2).__b;
(0, $13c8b89034f966ca$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $bb8b933278227e3b$var$T && $bb8b933278227e3b$var$T(n);
};
var $bb8b933278227e3b$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $bb8b933278227e3b$export$257a8862b851cb5b(n) {
    function t(t) {
        var _$e = $bb8b933278227e3b$var$g({}, t);
        return delete _$e.ref, n(_$e, t.ref || null);
    }
    return t.$$typeof = $bb8b933278227e3b$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $bb8b933278227e3b$var$L = function L(n, t) {
    return null == n ? null : (0, $13c8b89034f966ca$export$47e4c5b300681277)((0, $13c8b89034f966ca$export$47e4c5b300681277)(n).map(t));
}, $bb8b933278227e3b$export$dca3b0875bd9a954 = {
    map: $bb8b933278227e3b$var$L,
    forEach: $bb8b933278227e3b$var$L,
    count: function count(n) {
        return n ? (0, $13c8b89034f966ca$export$47e4c5b300681277)(n).length : 0;
    },
    only: function only(n) {
        var _$t = (0, $13c8b89034f966ca$export$47e4c5b300681277)(n);
        if (1 !== _$t.length) throw "Children.only";
        return _$t[0];
    },
    toArray: (0, $13c8b89034f966ca$export$47e4c5b300681277)
}, $bb8b933278227e3b$var$U = (0, $13c8b89034f966ca$export$41c562ebe57d11e2).__e;
(0, $13c8b89034f966ca$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var _$u, o = t; o = o.__;)if ((_$u = o.__c) && _$u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), _$u.__c(n, t);
    }
    $bb8b933278227e3b$var$U(n, t, e, r);
};
var $bb8b933278227e3b$var$F = (0, $13c8b89034f966ca$export$41c562ebe57d11e2).unmount;
function $bb8b933278227e3b$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $bb8b933278227e3b$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $bb8b933278227e3b$var$V(n, t, e);
    })), n;
}
function $bb8b933278227e3b$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $bb8b933278227e3b$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $bb8b933278227e3b$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $bb8b933278227e3b$var$j(n) {
    if (!n.__) return null;
    var _$t = n.__.__c;
    return _$t && _$t.__a && _$t.__a(n);
}
function $bb8b933278227e3b$export$488013bae63b21da(n) {
    var _$e, _$r, _$u, o = null;
    function i(i) {
        if (_$e || (_$e = n()).then(function(n) {
            n && (o = n.default || n), _$u = !0;
        }, function(n) {
            _$r = n, _$u = !0;
        }), _$r) throw _$r;
        if (!_$u) throw _$e;
        return o ? (0, $13c8b89034f966ca$export$c8a8987d4410bf2d)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $bb8b933278227e3b$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $13c8b89034f966ca$export$41c562ebe57d11e2).unmount = function(n) {
    var _$t = n.__c;
    _$t && (_$t.__z = !0), _$t && _$t.__R && _$t.__R(), _$t && 32 & n.__u && (n.type = null), $bb8b933278227e3b$var$F && $bb8b933278227e3b$var$F(n);
}, ($bb8b933278227e3b$export$74bf444e3cd11ea5.prototype = new (0, $13c8b89034f966ca$export$16fa2f45be04daa8)).__c = function(n, t) {
    var _$e = t.__c, _$r = this;
    null == _$r.o && (_$r.o = []), _$r.o.push(_$e);
    var _$u = $bb8b933278227e3b$var$j(_$r.__v), o = !1, i = function i() {
        o || _$r.__z || (o = !0, _$e.__R = null, _$u ? _$u(_$c) : _$c());
    };
    _$e.__R = i;
    var _$l = _$e.__P;
    _$e.__P = null;
    var _$c = function c() {
        if (!--_$r.__u) {
            if (_$r.state.__a) {
                var _$n = _$r.state.__a;
                _$r.__v.__k[0] = $bb8b933278227e3b$var$W(_$n, _$n.__c.__P, _$n.__c.__O);
            }
            var _$t;
            for(_$r.setState({
                __a: _$r.__b = null
            }); _$t = _$r.o.pop();)_$t.__P = _$l, _$t.forceUpdate();
        }
    };
    _$r.__u++ || 32 & t.__u || _$r.setState({
        __a: _$r.__b = _$r.__v.__k[0]
    }), n.then(i, i);
}, $bb8b933278227e3b$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $bb8b933278227e3b$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var _$r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $bb8b933278227e3b$var$V(this.__b, _$r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $13c8b89034f966ca$export$c8a8987d4410bf2d)((0, $13c8b89034f966ca$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $13c8b89034f966ca$export$c8a8987d4410bf2d)((0, $13c8b89034f966ca$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $bb8b933278227e3b$var$H = function H(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $bb8b933278227e3b$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $bb8b933278227e3b$var$Y(n) {
    var _$e = this, _$r = n.h;
    if (_$e.componentWillUnmount = function() {
        (0, $13c8b89034f966ca$export$b3890eb0ae9dca99)(null, _$e.v), _$e.v = null, _$e.h = null;
    }, _$e.h && _$e.h !== _$r && _$e.componentWillUnmount(), !_$e.v) {
        for(var _$u = _$e.__v; null !== _$u && !_$u.__m && null !== _$u.__;)_$u = _$u.__;
        _$e.h = _$r, _$e.v = {
            nodeType: 1,
            parentNode: _$r,
            childNodes: [],
            __k: {
                __m: _$u.__m
            },
            contains: function contains() {
                return !0;
            },
            namespaceURI: _$r.namespaceURI,
            insertBefore: function insertBefore(n, t) {
                this.childNodes.push(n), _$e.h.insertBefore(n, t);
            },
            removeChild: function removeChild(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), _$e.h.removeChild(n);
            }
        };
    }
    (0, $13c8b89034f966ca$export$b3890eb0ae9dca99)((0, $13c8b89034f966ca$export$c8a8987d4410bf2d)($bb8b933278227e3b$var$Z, {
        context: _$e.context
    }, n.__v), _$e.v);
}
function $bb8b933278227e3b$export$d39a5bbd09211389(n, e) {
    var _$r = (0, $13c8b89034f966ca$export$c8a8987d4410bf2d)($bb8b933278227e3b$var$Y, {
        __v: n,
        h: e
    });
    return _$r.containerInfo = e, _$r;
}
($bb8b933278227e3b$export$998bcd577473dd93.prototype = new (0, $13c8b89034f966ca$export$16fa2f45be04daa8)).__a = function(n) {
    var _$t = this, _$e = $bb8b933278227e3b$var$j(_$t.__v), _$r = _$t.l.get(n);
    return _$r[0]++, function(u) {
        var o = function o() {
            _$t.props.revealOrder ? (_$r.push(u), $bb8b933278227e3b$var$H(_$t, n, _$r)) : u();
        };
        _$e ? _$e(o) : o();
    };
}, $bb8b933278227e3b$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var _$t = (0, $13c8b89034f966ca$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && _$t.reverse();
    for(var _$e = _$t.length; _$e--;)this.l.set(_$t[_$e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $bb8b933278227e3b$export$998bcd577473dd93.prototype.componentDidUpdate = $bb8b933278227e3b$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var _$n = this;
    this.l.forEach(function(t, e) {
        $bb8b933278227e3b$var$H(_$n, e, t);
    });
};
var $bb8b933278227e3b$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $bb8b933278227e3b$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $bb8b933278227e3b$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $bb8b933278227e3b$var$K = /[A-Z0-9]/g, $bb8b933278227e3b$var$Q = "undefined" != typeof document, $bb8b933278227e3b$var$X = function X(n) {
    return ("undefined" != typeof Symbol && "symbol" == (0, $3911bfce698fbe4a$export$71511d61b312f219)(Symbol()) ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $bb8b933278227e3b$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $13c8b89034f966ca$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $bb8b933278227e3b$export$fa8d919ba61d84db(n, t, e) {
    return (0, $13c8b89034f966ca$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $13c8b89034f966ca$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $13c8b89034f966ca$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function get() {
            return this["UNSAFE_" + t];
        },
        set: function set(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $bb8b933278227e3b$var$en = (0, $13c8b89034f966ca$export$41c562ebe57d11e2).event;
function $bb8b933278227e3b$var$rn() {}
function $bb8b933278227e3b$var$un() {
    return this.cancelBubble;
}
function $bb8b933278227e3b$var$on() {
    return this.defaultPrevented;
}
(0, $13c8b89034f966ca$export$41c562ebe57d11e2).event = function(n) {
    return $bb8b933278227e3b$var$en && (n = $bb8b933278227e3b$var$en(n)), n.persist = $bb8b933278227e3b$var$rn, n.isPropagationStopped = $bb8b933278227e3b$var$un, n.isDefaultPrevented = $bb8b933278227e3b$var$on, n.nativeEvent = n;
};
var $bb8b933278227e3b$var$ln, $bb8b933278227e3b$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function get() {
        return this.class;
    }
}, $bb8b933278227e3b$var$fn = (0, $13c8b89034f966ca$export$41c562ebe57d11e2).vnode;
(0, $13c8b89034f966ca$export$41c562ebe57d11e2).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var _$t = n.props, _$e = n.type, _$u = {}, o = -1 === _$e.indexOf("-");
        for(var i in _$t){
            var _$l = _$t[i];
            if (!("value" === i && "defaultValue" in _$t && null == _$l || $bb8b933278227e3b$var$Q && "children" === i && "noscript" === _$e || "class" === i || "className" === i)) {
                var _$c = i.toLowerCase();
                "defaultValue" === i && "value" in _$t && null == _$t.value ? i = "value" : "download" === i && !0 === _$l ? _$l = "" : "translate" === _$c && "no" === _$l ? _$l = !1 : "o" === _$c[0] && "n" === _$c[1] ? "ondoubleclick" === _$c ? i = "ondblclick" : "onchange" !== _$c || "input" !== _$e && "textarea" !== _$e || $bb8b933278227e3b$var$X(_$t.type) ? "onfocus" === _$c ? i = "onfocusin" : "onblur" === _$c ? i = "onfocusout" : $bb8b933278227e3b$var$J.test(i) && (i = _$c) : _$c = i = "oninput" : o && $bb8b933278227e3b$var$G.test(i) ? i = i.replace($bb8b933278227e3b$var$K, "-$&").toLowerCase() : null === _$l && (_$l = void 0), "oninput" === _$c && _$u[i = _$c] && (i = "oninputCapture"), _$u[i] = _$l;
            }
        }
        "select" == _$e && _$u.multiple && Array.isArray(_$u.value) && (_$u.value = (0, $13c8b89034f966ca$export$47e4c5b300681277)(_$t.children).forEach(function(n) {
            n.props.selected = -1 != _$u.value.indexOf(n.props.value);
        })), "select" == _$e && null != _$u.defaultValue && (_$u.value = (0, $13c8b89034f966ca$export$47e4c5b300681277)(_$t.children).forEach(function(n) {
            n.props.selected = _$u.multiple ? -1 != _$u.defaultValue.indexOf(n.props.value) : _$u.defaultValue == n.props.value;
        })), _$t.class && !_$t.className ? (_$u.class = _$t.class, Object.defineProperty(_$u, "className", $bb8b933278227e3b$var$cn)) : _$t.className && (_$u.class = _$u.className = _$t.className), n.props = _$u;
    }(n), n.$$typeof = $bb8b933278227e3b$var$q, $bb8b933278227e3b$var$fn && $bb8b933278227e3b$var$fn(n);
};
var $bb8b933278227e3b$var$an = (0, $13c8b89034f966ca$export$41c562ebe57d11e2).__r;
(0, $13c8b89034f966ca$export$41c562ebe57d11e2).__r = function(n) {
    $bb8b933278227e3b$var$an && $bb8b933278227e3b$var$an(n), $bb8b933278227e3b$var$ln = n.__c;
};
var $bb8b933278227e3b$var$sn = (0, $13c8b89034f966ca$export$41c562ebe57d11e2).diffed;
(0, $13c8b89034f966ca$export$41c562ebe57d11e2).diffed = function(n) {
    $bb8b933278227e3b$var$sn && $bb8b933278227e3b$var$sn(n);
    var _$t = n.props, _$e = n.__e;
    null != _$e && "textarea" === n.type && "value" in _$t && _$t.value !== _$e.value && (_$e.value = null == _$t.value ? "" : _$t.value), $bb8b933278227e3b$var$ln = null;
};
var $bb8b933278227e3b$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function readContext(n) {
                return $bb8b933278227e3b$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $dcc8496ca7afa43a$export$35808ee640e87ca7),
            useContext: (0, $dcc8496ca7afa43a$export$fae74005e78b1a27),
            useDebugValue: (0, $dcc8496ca7afa43a$export$dc8fbce3eb94dc1e),
            useDeferredValue: $bb8b933278227e3b$export$6a7bc4e911dc01cf,
            useEffect: (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591),
            useId: (0, $dcc8496ca7afa43a$export$f680877a34711e37),
            useImperativeHandle: (0, $dcc8496ca7afa43a$export$d5a552a76deda3c2),
            useInsertionEffect: $bb8b933278227e3b$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $dcc8496ca7afa43a$export$e5c5a5f917a5871c),
            useMemo: (0, $dcc8496ca7afa43a$export$1538c33de8887b59),
            useReducer: (0, $dcc8496ca7afa43a$export$13e3392192263954),
            useRef: (0, $dcc8496ca7afa43a$export$b8f5890fc79d6aca),
            useState: (0, $dcc8496ca7afa43a$export$60241385465d0a34),
            useSyncExternalStore: $bb8b933278227e3b$export$306c0aa65ff9ec16,
            useTransition: $bb8b933278227e3b$export$7b286972b8d8ccbf
        }
    }
}, $bb8b933278227e3b$export$83d89fbfd8236492 = "18.3.1";
function $bb8b933278227e3b$export$d38cd72104c1f0e9(n) {
    return (0, $13c8b89034f966ca$export$c8a8987d4410bf2d).bind(null, n);
}
function $bb8b933278227e3b$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $bb8b933278227e3b$var$q;
}
function $bb8b933278227e3b$export$9522e17588c12572(n) {
    return $bb8b933278227e3b$export$a8257692ac88316c(n) && n.type === (0, $13c8b89034f966ca$export$ffb0004e005737fa);
}
function $bb8b933278227e3b$export$56885ab8b9c456ab(n) {
    return !!n && "string" == typeof n.displayName && n.displayName.startsWith("Memo(");
}
function $bb8b933278227e3b$export$e530037191fcd5d7(n) {
    return $bb8b933278227e3b$export$a8257692ac88316c(n) ? (0, $13c8b89034f966ca$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $bb8b933278227e3b$export$502457920280e6be(n) {
    return !!n.__k && ((0, $13c8b89034f966ca$export$b3890eb0ae9dca99)(null, n), !0);
}
function $bb8b933278227e3b$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $bb8b933278227e3b$export$c78a37762a8d58e1 = function gn(n, t) {
    return n(t);
}, $bb8b933278227e3b$export$cd75ccfd720a3cd4 = function En(n, t) {
    return n(t);
}, $bb8b933278227e3b$export$5f8d39834fd61797 = (0, $13c8b89034f966ca$export$ffb0004e005737fa), $bb8b933278227e3b$export$45a5e7f76e0caa8d = $bb8b933278227e3b$export$a8257692ac88316c, $bb8b933278227e3b$export$2e2bcd8739ae039 = {
    useState: (0, $dcc8496ca7afa43a$export$60241385465d0a34),
    useId: (0, $dcc8496ca7afa43a$export$f680877a34711e37),
    useReducer: (0, $dcc8496ca7afa43a$export$13e3392192263954),
    useEffect: (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $dcc8496ca7afa43a$export$e5c5a5f917a5871c),
    useInsertionEffect: $bb8b933278227e3b$export$aaabe4eda9ed9969,
    useTransition: $bb8b933278227e3b$export$7b286972b8d8ccbf,
    useDeferredValue: $bb8b933278227e3b$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $bb8b933278227e3b$export$306c0aa65ff9ec16,
    startTransition: $bb8b933278227e3b$export$7568632d0d33d16d,
    useRef: (0, $dcc8496ca7afa43a$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $dcc8496ca7afa43a$export$d5a552a76deda3c2),
    useMemo: (0, $dcc8496ca7afa43a$export$1538c33de8887b59),
    useCallback: (0, $dcc8496ca7afa43a$export$35808ee640e87ca7),
    useContext: (0, $dcc8496ca7afa43a$export$fae74005e78b1a27),
    useDebugValue: (0, $dcc8496ca7afa43a$export$dc8fbce3eb94dc1e),
    version: "18.3.1",
    Children: $bb8b933278227e3b$export$dca3b0875bd9a954,
    render: $bb8b933278227e3b$export$b3890eb0ae9dca99,
    hydrate: $bb8b933278227e3b$export$fa8d919ba61d84db,
    unmountComponentAtNode: $bb8b933278227e3b$export$502457920280e6be,
    createPortal: $bb8b933278227e3b$export$d39a5bbd09211389,
    createElement: (0, $13c8b89034f966ca$export$c8a8987d4410bf2d),
    createContext: (0, $13c8b89034f966ca$export$fd42f52fd3ae1109),
    createFactory: $bb8b933278227e3b$export$d38cd72104c1f0e9,
    cloneElement: $bb8b933278227e3b$export$e530037191fcd5d7,
    createRef: (0, $13c8b89034f966ca$export$7d1e3a5e95ceca43),
    Fragment: (0, $13c8b89034f966ca$export$ffb0004e005737fa),
    isValidElement: $bb8b933278227e3b$export$a8257692ac88316c,
    isElement: $bb8b933278227e3b$export$45a5e7f76e0caa8d,
    isFragment: $bb8b933278227e3b$export$9522e17588c12572,
    isMemo: $bb8b933278227e3b$export$56885ab8b9c456ab,
    findDOMNode: $bb8b933278227e3b$export$466bfc07425424d5,
    Component: (0, $13c8b89034f966ca$export$16fa2f45be04daa8),
    PureComponent: $bb8b933278227e3b$export$221d75b3f55bb0bd,
    memo: $bb8b933278227e3b$export$7c73462e0d25e514,
    forwardRef: $bb8b933278227e3b$export$257a8862b851cb5b,
    flushSync: $bb8b933278227e3b$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $bb8b933278227e3b$export$c78a37762a8d58e1,
    StrictMode: $bb8b933278227e3b$export$5f8d39834fd61797,
    Suspense: $bb8b933278227e3b$export$74bf444e3cd11ea5,
    SuspenseList: $bb8b933278227e3b$export$998bcd577473dd93,
    lazy: $bb8b933278227e3b$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $bb8b933278227e3b$export$ae55be85d98224ed
};


// Animation duration in ms (should match CSS transition times)
var $0977da0e31d990a3$var$ENTER_ANIMATION_DURATION = 100;
var $0977da0e31d990a3$var$EXIT_ANIMATION_DURATION = 350;
function $0977da0e31d990a3$var$ModalDialog(param) {
    var isOpen = param.isOpen, onClose = param.onClose, closeSlot = param.closeSlot, contentSlot = param.contentSlot;
    var overlayRef = (0, $dcc8496ca7afa43a$export$b8f5890fc79d6aca)(null);
    var panelRef = (0, $dcc8496ca7afa43a$export$b8f5890fc79d6aca)(null);
    var closeContainerRef = (0, $dcc8496ca7afa43a$export$b8f5890fc79d6aca)(null);
    var contentContainerRef = (0, $dcc8496ca7afa43a$export$b8f5890fc79d6aca)(null);
    var previousActiveElement = (0, $dcc8496ca7afa43a$export$b8f5890fc79d6aca)(null);
    // Track render state: 'hidden' | 'entering' | 'open' | 'exiting'
    var _useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $dcc8496ca7afa43a$export$60241385465d0a34)('hidden'), 2), renderState = _useState[0], setRenderState = _useState[1];
    // Handle open transition
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (isOpen && renderState === 'hidden') // Start entering - mount the element first
        setRenderState('entering');
        else if (!isOpen && (renderState === 'open' || renderState === 'entering')) // Start exiting
        setRenderState('exiting');
    }, [
        isOpen,
        renderState
    ]);
    // Handle entering -> open transition (after mount, trigger CSS animation)
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (renderState === 'entering') {
            // Double RAF to ensure DOM is painted before adding is-open class
            var raf1 = requestAnimationFrame(function() {
                var raf2 = requestAnimationFrame(function() {
                    setRenderState('open');
                });
                return function() {
                    return cancelAnimationFrame(raf2);
                };
            });
            return function() {
                return cancelAnimationFrame(raf1);
            };
        }
    }, [
        renderState
    ]);
    // Handle exiting -> hidden transition (after animation completes)
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (renderState === 'exiting') {
            var timer = setTimeout(function() {
                setRenderState('hidden');
            }, $0977da0e31d990a3$var$EXIT_ANIMATION_DURATION);
            return function() {
                return clearTimeout(timer);
            };
        }
    }, [
        renderState
    ]);
    // Move slotted elements into the modal when visible
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        var isVisible = renderState !== 'hidden';
        if (closeSlot) {
            if (isVisible && closeContainerRef.current) {
                closeSlot.style.display = '';
                closeContainerRef.current.appendChild(closeSlot);
            } else if (!isVisible) closeSlot.style.display = 'none';
        }
        if (contentSlot) {
            if (isVisible && contentContainerRef.current) {
                contentSlot.style.display = '';
                contentContainerRef.current.appendChild(contentSlot);
            } else if (!isVisible) contentSlot.style.display = 'none';
        }
    }, [
        renderState,
        closeSlot,
        contentSlot
    ]);
    // Handle close button click
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (closeSlot && renderState === 'open') {
            var handleClose = function(e) {
                e.preventDefault();
                e.stopPropagation();
                onClose();
            };
            closeSlot.addEventListener('click', handleClose);
            return function() {
                return closeSlot.removeEventListener('click', handleClose);
            };
        }
    }, [
        closeSlot,
        renderState,
        onClose
    ]);
    // Handle escape key
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (renderState === 'open') {
            var handleKeyDown = function(e) {
                if (e.key === 'Escape') onClose();
            };
            document.addEventListener('keydown', handleKeyDown);
            return function() {
                return document.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        renderState,
        onClose
    ]);
    // Focus management and body scroll lock
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (renderState === 'open') {
            // Store the currently focused element
            previousActiveElement.current = document.activeElement;
            // Lock body scroll
            document.body.style.overflow = 'hidden';
            // Make everything else inert (except the portal container)
            document.querySelectorAll('body > *:not(.x-profile-modal-portal)').forEach(function(el) {
                if (el instanceof HTMLElement) {
                    el.setAttribute('inert', '');
                    el.setAttribute('aria-hidden', 'true');
                }
            });
            // Focus the modal panel
            setTimeout(function() {
                if (panelRef.current) panelRef.current.focus();
            }, $0977da0e31d990a3$var$ENTER_ANIMATION_DURATION);
        }
        return function() {
            if (renderState === 'open') {
                document.body.style.overflow = '';
                document.querySelectorAll('body > *[inert]').forEach(function(el) {
                    if (el instanceof HTMLElement) {
                        el.removeAttribute('inert');
                        el.removeAttribute('aria-hidden');
                    }
                });
                // Restore focus to the trigger element
                if (previousActiveElement.current) previousActiveElement.current.focus();
            }
        };
    }, [
        renderState
    ]);
    // Trap focus within modal
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (renderState !== 'open' || !panelRef.current) return;
        var handleTabKey = function(e) {
            if (e.key !== 'Tab') return;
            var focusableElements = panelRef.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (focusableElements.length === 0) return;
            var firstElement = focusableElements[0];
            var lastElement = focusableElements[focusableElements.length - 1];
            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else if (document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        };
        document.addEventListener('keydown', handleTabKey);
        return function() {
            return document.removeEventListener('keydown', handleTabKey);
        };
    }, [
        renderState
    ]);
    // Don't render if hidden
    if (renderState === 'hidden') return null;
    // Determine if the is-open class should be applied
    var showOpenClass = renderState === 'open';
    // Render the modal to a portal at the body level
    return (0, $bb8b933278227e3b$export$d39a5bbd09211389)(/*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)("div", {
        ref: overlayRef,
        className: "team-modal-overlay ".concat(showOpenClass ? 'is-open' : ''),
        children: [
            /*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)("div", {
                className: "team-modal-backdrop",
                onClick: onClose,
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)("div", {
                className: "team-modal-container",
                children: /*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)("div", {
                    ref: panelRef,
                    role: "dialog",
                    "aria-modal": "true",
                    tabIndex: -1,
                    className: "team-modal-panel",
                    children: [
                        /*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)("div", {
                            ref: closeContainerRef,
                            className: "absolute top-16 right-16 z-10"
                        }),
                        /*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)("div", {
                            ref: contentContainerRef,
                            className: "team-modal-content"
                        })
                    ]
                })
            })
        ]
    }), $0977da0e31d990a3$var$getPortalContainer());
}
// Get or create a portal container at the body level
function $0977da0e31d990a3$var$getPortalContainer() {
    var container = document.querySelector('.x-profile-modal-portal');
    if (!container) {
        container = document.createElement('div');
        container.className = 'x-profile-modal-portal';
        document.body.appendChild(container);
    }
    return container;
}
function $0977da0e31d990a3$var$ProfileModalComponent(param) {
    var triggerSlot = param.triggerSlot, closeSlot = param.closeSlot, contentSlot = param.contentSlot;
    var _useState = (0, $c6938abc98c6418f$export$71511d61b312f219)((0, $dcc8496ca7afa43a$export$60241385465d0a34)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var triggerContainerRef = (0, $dcc8496ca7afa43a$export$b8f5890fc79d6aca)(null);
    var handleClose = (0, $dcc8496ca7afa43a$export$35808ee640e87ca7)(function() {
        setIsOpen(false);
    }, []);
    var handleOpen = (0, $dcc8496ca7afa43a$export$35808ee640e87ca7)(function() {
        setIsOpen(true);
    }, []);
    // Move trigger slot into container
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (triggerContainerRef.current && triggerSlot) triggerContainerRef.current.appendChild(triggerSlot);
    }, [
        triggerSlot
    ]);
    // Attach trigger click handler
    (0, $dcc8496ca7afa43a$export$6d9c69b0de29b591)(function() {
        if (triggerSlot) {
            triggerSlot.addEventListener('click', handleOpen);
            // Add keyboard support
            triggerSlot.setAttribute('tabindex', '0');
            triggerSlot.setAttribute('role', 'button');
            var handleKeyDown = function(e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsOpen(true);
                }
            };
            triggerSlot.addEventListener('keydown', handleKeyDown);
            return function() {
                triggerSlot.removeEventListener('click', handleOpen);
                triggerSlot.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        triggerSlot,
        handleOpen
    ]);
    return /*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)((0, $13c8b89034f966ca$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)("div", {
                ref: triggerContainerRef,
                style: {
                    display: 'contents'
                }
            }),
            /*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)($0977da0e31d990a3$var$ModalDialog, {
                isOpen: isOpen,
                onClose: handleClose,
                closeSlot: closeSlot,
                contentSlot: contentSlot
            })
        ]
    });
}
// Web Component definition
var $0977da0e31d990a3$var$XProfileModal = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $5ddaf6e638d3c6b1$export$71511d61b312f219)(XProfileModal, HTMLElement1);
    function XProfileModal() {
        (0, $bf2e53ae99fda9f5$export$71511d61b312f219)(this, XProfileModal);
        var _this;
        _this = (0, $27fc2d546b8e5514$export$71511d61b312f219)(this, XProfileModal, arguments), (0, $2b1f4dace316f7be$export$71511d61b312f219)(_this, "_mounted", false), (0, $2b1f4dace316f7be$export$71511d61b312f219)(_this, "_triggerSlot", null), (0, $2b1f4dace316f7be$export$71511d61b312f219)(_this, "_closeSlot", null), (0, $2b1f4dace316f7be$export$71511d61b312f219)(_this, "_contentSlot", null), (0, $2b1f4dace316f7be$export$71511d61b312f219)(_this, "_renderRoot", null);
        return _this;
    }
    (0, $ac98c22c37821d14$export$71511d61b312f219)(XProfileModal, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var // Remove slot attributes so they don't interfere
                _this__triggerSlot, _this__closeSlot, _this__contentSlot;
                if (this._mounted) return;
                this._mounted = true;
                // Extract slotted elements before rendering
                this._triggerSlot = this.querySelector('[slot="trigger"]');
                this._closeSlot = this.querySelector('[slot="close"]');
                this._contentSlot = this.querySelector('[slot="content"]');
                (_this__triggerSlot = this._triggerSlot) === null || _this__triggerSlot === void 0 ? void 0 : _this__triggerSlot.removeAttribute('slot');
                (_this__closeSlot = this._closeSlot) === null || _this__closeSlot === void 0 ? void 0 : _this__closeSlot.removeAttribute('slot');
                (_this__contentSlot = this._contentSlot) === null || _this__contentSlot === void 0 ? void 0 : _this__contentSlot.removeAttribute('slot');
                // Hide close and content slots initially
                if (this._closeSlot) this._closeSlot.style.display = 'none';
                if (this._contentSlot) this._contentSlot.style.display = 'none';
                // Create a render root
                this._renderRoot = document.createElement('div');
                this._renderRoot.style.display = 'contents';
                this.appendChild(this._renderRoot);
                this._render();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                if (this._renderRoot) (0, $13c8b89034f966ca$export$b3890eb0ae9dca99)(null, this._renderRoot);
                this._mounted = false;
            }
        },
        {
            key: "_render",
            value: function _render() {
                if (!this._renderRoot) return;
                (0, $13c8b89034f966ca$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $be8386bd25ce61d4$export$34b9dba7ce09269b)($0977da0e31d990a3$var$ProfileModalComponent, {
                    triggerSlot: this._triggerSlot,
                    closeSlot: this._closeSlot,
                    contentSlot: this._contentSlot
                }), this._renderRoot);
            }
        }
    ]);
    return XProfileModal;
}((0, $2ad5a62b12ac1a0c$export$71511d61b312f219)(HTMLElement));
// Register the custom element
if (!customElements.get('x-profile-modal')) customElements.define('x-profile-modal', $0977da0e31d990a3$var$XProfileModal);
var $0977da0e31d990a3$export$2e2bcd8739ae039 = $0977da0e31d990a3$var$XProfileModal;


(0, $fcaf52c06ad2e684$export$68c286be0e7e55b7)();
(0, $533656838d3b3c79$export$2e2bcd8739ae039)();
(0, $0067abc1dfa9ab4c$export$7cb32b21c01a8e9a)();
(0, $0067abc1dfa9ab4c$export$1117968d46e6cacc)();

})();
//# sourceMappingURL=app.js.map
